import {
    Button,
    Stack,
    Tooltip,
    WrapItem,
} from '@chakra-ui/react'
import {
    CheckCircleIcon,
    WarningIcon,
    WarningTwoIcon,
} from '@chakra-ui/icons'

import {
    useDispatch,
    useSelector,
} from 'react-redux'

import { matchRoute } from '../features/railRoutes/railRouteSlice'
import UserReportPopover from './UserReportPopover'

export default function RoutePreviewButton({ isDisabled, formValues, overwriteMatchRoute }) {

    const { isLoading, isError, isSuccess, didFindRoute, routerRequestLogRecordId } = useSelector((state) => state.routes)

    const dispatch = useDispatch()

    function previewRouteOnClick() {
        if (formValues.originId !== '' && formValues.destinationId !== '') {
            if (overwriteMatchRoute !== undefined) {
                dispatch(overwriteMatchRoute({ // Capability preview no authentication, seperate server
                    originId: formValues.origin._id,
                    destinationId: formValues.destination._id,
                    viaPointsIds: formValues.viaPointsIds,
                    routingOptions: formValues.routingOptions,
                }))
            } else {
                dispatch(matchRoute({
                    originId: formValues.origin._id,
                    destinationId: formValues.destination._id,
                    viaPointsIds: formValues.viaPointsIds,
                    routingOptions: formValues.routingOptions,
                }))
            }
        }
    }

    return (
        <>
            <Stack
                direction='row'
                spacing={4}
                align='center'
            >
                <Button
                    variant='outline'
                    isLoading={isLoading}
                    onClick={previewRouteOnClick}
                    isDisabled={isDisabled ? true : (!(formValues.origin && formValues.destination) || isLoading)}
                >
                    Preview route
                </Button>
                
                {(isSuccess && didFindRoute) && (<CheckCircleIcon />)}
                {(isSuccess && !didFindRoute) && (
                    <UserReportPopover
                        type='unmappedRoute'
                        routerRequestLogRecordId={routerRequestLogRecordId}
                    >
                        <Button variant='link' colorScheme='blue' leftIcon={<WarningIcon />}>
                            Learn more
                        </Button>
                    </UserReportPopover>
                )}
                {isError && (
                    <WrapItem>
                        <Tooltip
                            label="Unable to find route due to an internal error. Please try again."
                        >
                            <WarningTwoIcon color='red.500' />
                        </Tooltip>
                    </WrapItem>
                )}
            </Stack>
        </>
    )
}